export default __webpack_public_path__ + "static/media/O-103.0679781b.png";